function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "linkedinIconTitle"
}, "Linkedin");

var _ref3 = /*#__PURE__*/React.createElement("desc", {
  id: "linkedinIconDesc"
}, "Linkedin icon");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M29.43,0C13.19,0,0,13.19,0,29.43C0,45.7,13.19,58.89,29.43,58.89c16.27,0,29.46-13.19,29.46-29.46 C58.89,13.17,45.7,0,29.43,0L29.43,0z M22.09,43.71h-7.37V17.93h7.37V43.71z M18.64,16.37c-1.9,0-3.45-1.55-3.45-3.47 c0-1.9,1.55-3.45,3.45-3.45c1.9,0.02,3.45,1.56,3.45,3.45C22.09,14.83,20.54,16.37,18.64,16.37L18.64,16.37z M47.84,43.71h-7.35 V27.78c0-1.87-0.54-3.18-2.82-3.18c-3.81,0-4.55,3.18-4.55,3.18v15.92h-7.35V17.93h7.35v2.47c1.06-0.79,3.69-2.45,7.37-2.45 c2.39,0,7.35,1.42,7.35,10.05V43.71z M47.84,43.71"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.89 58.89",
    xmlSpace: "preserve",
    "aria-labelledby": "linkedinIconTitle linkedinIconDesc",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "linkedinIconTitle"
  }, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.76c8cc99.svg";
export { ForwardRef as ReactComponent };